import React, { Component } from "react";
import axios from "axios";
import * as urls from "../common/urls";
import { withTranslation } from 'react-i18next';

class ProductBundleOptions extends Component {
  //state = { variations: this.props.variations };

  //  componentDidUpdate(prevProps) {
  //      if (prevProps.variations !== this.props.variations) {
  //          this.setState({
  //              variations: this.props.variations
  //          });
  //      }
  //}

  onCombinationsChanged = event => {
    let allCombinationsSelected = true;
    let selectedCombinationsIds = [];
      for (let index = 0; index < this.props.combinations.length; index++) {
        const elem = this[`combination${index}`];
      selectedCombinationsIds.push(elem.value);
      if (elem.value === "-1") {
        allCombinationsSelected = false;
      }
    }
    const allCombinationsIds = selectedCombinationsIds.join(",");

      if (allCombinationsSelected) {
          this.props.onAllProductOptionsSelected(allCombinationsIds);
      }
      else {
          this.props.onAllProductOptionsSelected(null);
      }
  };

    render() {
        const { combinations, t } = this.props;
        if (!combinations) return <div />;

        const combinationsList = combinations.map((combination, i) => {

            const stockOptions = combination.stockItems.map((stock, i) => (
                <option key={stock.id} value={stock.id}>
                {stock.nameTranslation}
                </option>));

            return (<div className="col-sm-4" key={combination.choiceIndex}>
                <div className="form-group">
                    <label>{`${t("Choice")} ${combination.choiceIndex}`}</label>
                    <select
                        className="form-control"
                        onChange={this.onCombinationsChanged}
                        ref={select => (this[`combination${i}`] = select)}
                    >
                        <option key="-1" value="-1">{t("Please select")} </option>
                        {stockOptions}
                    </select>
                </div>
            </div>);
    
    });

    return <div className="row margin-top-1x">{combinationsList}</div>;
  }
}

export default withTranslation()(ProductBundleOptions);
